import { TypedAction } from '@ngrx/store/src/models';
import { setLivingSpaceFilterBasedOnUrlValues } from './living-space.actions';
import { AppState, UrlPartSerializer } from '@immosky/types';

export class LivingSpaceFilterSerializer implements UrlPartSerializer {
  constructor(public readonly key: string) {}

  deserialize(urlValue: string): TypedAction<string> {
    const values = urlValue.split(',').map((v) => v.trim());

    const min = parseInt(values[0], 10);
    const max = parseInt(values[1], 10);

    return setLivingSpaceFilterBasedOnUrlValues({
      values: {
        min,
        max,
      },
    });
  }

  serialize(state: AppState): string {
    const livingSpaceFilter = state.filter.livingSpace.filter;
    return `${livingSpaceFilter.min.value},${livingSpaceFilter.max.value}`;
  }
}
